import { FilterItemNodeWithId } from "@/components/pages/common/filters-tree/utils/types/common";
import { PostUsersMeOrganisationsCurrentByProviderAndValidationFilterTypeValidValuesApiArg } from "@/services/cloudchipr.api";

export const getBatchValuesFromText = (text: string) => {
  return text
    .split(/[\s]*,[\s]*|\n+/) // split by "," || ", " || newlines
    .map((value) => value.trim())
    .filter((value) => value !== "");
};

export const generateValidatorPayload = (
  filter: FilterItemNodeWithId,
  values: string[],
  filterValueKey?: string,
) => {
  const provider = filter.filter_provider;
  const filterType = filter.type;

  const payload: PostUsersMeOrganisationsCurrentByProviderAndValidationFilterTypeValidValuesApiArg =
    {
      provider: provider,
      validationFilterType: "",
      body: { filter_values: values },
    };

  const validationFilterType = validationFilterTypeByFilterType[filterType];

  if (filterValueKey) {
    payload.tagKey = filterValueKey;
  }

  if (validationFilterType) {
    payload.validationFilterType = validationFilterType;
  }

  return payload;
};

const validationFilterTypeByFilterType: Record<string, string> = {
  tag: "tag_value",
  resource_id: "resource_id",
  parent_resource_id: "parent_resource_id",
};
